import React from 'react';

// Route components are code-split (React.lazy), each with its own JS/CSS
// chunk. Without this, a single failed chunk load throws inside <Suspense>
// and unmounts the entire app — including during pre-rendering, where a
// blank tree gets baked into the static HTML. Retry once via a full reload
// (chunk fetches are cheap and this recovers most transient failures);
// fall back to rendering nothing rather than a permanently blank throw.
const CHUNK_ERROR_PATTERN = /loading (css )?chunk .+ failed|chunkloaderror/i;
const RELOAD_FLAG = 'chunk-reload-attempted';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const isChunkError = CHUNK_ERROR_PATTERN.test(error?.message || '');
    if (isChunkError && typeof window !== 'undefined' && window.sessionStorage) {
      if (!window.sessionStorage.getItem(RELOAD_FLAG)) {
        window.sessionStorage.setItem(RELOAD_FLAG, '1');
        window.location.reload();
      }
    }
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}

export default ErrorBoundary;
